import { useSelector } from 'react-redux';
import { embedView, ROUTE_STARTUP_PATH } from 'routes';

const useCaptableBreadcrumb = (path, startup, captable) => {
  const literals = useSelector(state => state.i18n.literals.captable);
  const literalsCommon = useSelector(state => state.i18n.literals.common);

  const {
    CAP_TABLE,
    CAP_TABLE_OPERATIONS,
    CAP_TABLE_SHAREHOLDERS,
    setCapTable,
    setCapTableOperations,
    setCapTableShareHolders,
  } = ROUTE_STARTUP_PATH;

  const mapLiterals = {
    [CAP_TABLE]: {
      name: literalsCommon.summary,
      path: setCapTable(startup, captable),
    },
    [CAP_TABLE_OPERATIONS]: {
      name: literals.operations,
      path: setCapTableOperations(startup, captable),
    },
    [CAP_TABLE_SHAREHOLDERS]: {
      name: literals.shareholders,
      path: setCapTableShareHolders(startup, captable),
    },
  };
  return {
    routes: [
      { name: literals.title, path: path !== CAP_TABLE ? embedView(mapLiterals[CAP_TABLE].path) : null },
      { name: mapLiterals[path].name, path: embedView(mapLiterals[path].path) },
    ],
    nextRoutes: Object.keys(mapLiterals).map(key => ({
      name: mapLiterals[key].name,
      path: embedView(mapLiterals[key].path),
      actual: key === path,
    })),
  };
};

export default useCaptableBreadcrumb;
